"use strict";

angular.module("vendor")
.service("VendorInvoiceService", function(
    $resource, FlashBag, gettextCatalog, InvoiceSelectorUnregisteredServiceFactory, appConfig
) {
    const LISTING_URL = "/invoice/vendor/list/";
    var printInvoiceResource = $resource(appConfig.API_SERVER + "/invoice/vendor/bulk-action/pdf/print/");
    var emailInvoiceResource = $resource(appConfig.API_SERVER + "/invoice/vendor/bulk-action/pdf/email/");

    function VendorInvoiceService() {
        InvoiceSelectorUnregisteredServiceFactory.call(this, LISTING_URL);

        this.getBulkActionParams = function() {
            return {
                printInvoice: {
                    text: gettextCatalog.getString("Print Invoice"),
                    message: gettextCatalog.getString("Do you really want to generate pdf of theses invoices?"),
                    resource: printInvoiceResource,
                    successMessage: gettextCatalog.getString("Pdf was created successfully."),
                    modalTemplatePrefix: "invoice",
                    modalTemplatePackage: "vendor"
                },
                emailInvoice: {
                    text: gettextCatalog.getString("Email Invoice"),
                    message: gettextCatalog.getString("Do you really want to send generated pdf of theses invoices by email?"),
                    resource: emailInvoiceResource,
                    successMessage: gettextCatalog.getString("Email was sent successfully."),
                    modalTemplatePrefix: "email-invoice",
                    modalTemplatePackage: "vendor",
                    controller: "EmailInvoiceBulkActionConfirmationController",
                    controllerAs: "emailInvoiceBulkActionConfirmationCtrl"
                }
            };
        };

        this.getSingleActionParams = function() {
            return this.getBulkActionParams();
        };
    }

    return new VendorInvoiceService();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/invoice/vendor-invoice.service.js
// module id = 891
// module chunks = 0